import cs from "classnames";
import React from "react";

import "./Table.css";

export const Table: React.FunctionComponent<
	React.HTMLProps<HTMLTableElement>
> = ({ className, children, ...props }) => (
	<table className={cs("table", className)} {...props}>
		{children}
	</table>
);
